export default "__VITE_ASSET__C4Ou$73m__"